import { Types } from '@antv/g2';

export type Slider = Types.SliderOption;
